import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { api } from '@utils/api';
import { StatisticsResponse } from './StatisticsTypes';
import { ErrorResponse } from 'store/ReduxTypes';

/* ---------- GET /api/v1/statistics ---------- */
export const getStatisticsOperation = createAsyncThunk<
  StatisticsResponse,
  void,
  { rejectValue: ErrorResponse }
>('statistics/get', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get<StatisticsResponse>('/statistics');
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});
